export enum GameStatus {
    Waiting = 'waiting',
    Started = 'started',
    Ended = 'ended'
}
